// src/plugins/sentryPlugin.ts

import Vue, { VueConstructor } from 'vue'
import * as Sentry from '@sentry/vue'

// Patch prototype typing at definition time
declare module 'vue/types/vue' {
  interface Vue {
    $sentry: {
      captureException: typeof Sentry.captureException;
      captureMessage: typeof Sentry.captureMessage;
      captureEvent: typeof Sentry.captureEvent;
      addBreadcrumb: typeof Sentry.addBreadcrumb;
      setContext: typeof Sentry.setContext;
      setExtras: typeof Sentry.setExtras;
      setExtra: typeof Sentry.setExtra;
      setTag: typeof Sentry.setTag;
      setUser: typeof Sentry.setUser;
      withScope: typeof Sentry.withScope;
    }
  }
}

const enableSentry = process.env.VUE_APP_ENABLE_SENTRY === 'true'

Sentry.init({
  Vue,
  dsn: enableSentry
    ? 'https://ee59a0b3e4ca4081bdd19c8a5e5451a2@o351848.ingest.sentry.io/4505444835459072'
    : undefined,
  environment: process.env.NODE_ENV || 'production',
  integrations: [
    Sentry.breadcrumbsIntegration({
      console: true,
      dom: false,
      fetch: true,
      history: false
    }),
    Sentry.httpClientIntegration(),
    Sentry.extraErrorDataIntegration()
  ],
  sendDefaultPii: true
})

const sentryPlugin = {
  install (vue: VueConstructor): void {
    vue.prototype.$sentry = {
      captureException: Sentry.captureException,
      captureMessage: Sentry.captureMessage,
      captureEvent: Sentry.captureEvent,
      addBreadcrumb: Sentry.addBreadcrumb,
      setContext: Sentry.setContext,
      setExtras: Sentry.setExtras,
      setExtra: Sentry.setExtra,
      setTag: Sentry.setTag,
      setUser: Sentry.setUser,
      withScope: Sentry.withScope
    }
  }
}

export default sentryPlugin
